<template>
    <div class="plano-faturas-tabela">
        <az-container>
            <az-form style="padding: 0px">
                <div class="li-tabela">
                    <v-data-table :headers="colunas" :items="itens" :total-items="totalItens"
                                  :pagination.sync="paginacaoInterna" :loading="false"
                                  no-data-text="Nenhuma fatura encontrada"
                                  hide-actions class="az-table-list">
                        <template slot="items" slot-scope="props">
                            <td>{{ props.item.assinatura.planoProduto.nome }}</td>
                            <td>{{ props.item.assinatura.dataCriacao | azDate('DD/MM/YYYY') }}</td>
                            <td>{{ props.item.assinatura.dataLimite | azDate('DD/MM/YYYY') }}</td>
                            <td>{{ props.item.valor | valorParaReal }}</td>
                            <td>{{ props.item.tipoPagamento | azEnum(tipoPagamentoCobranca) }}</td>
                            <td :class="{ 'coluna-situacao-pendente' : props.item.situacao === 'PENDING'}">{{ props.item.situacao | azEnum(tipoSituacaoCobranca) }}</td>
                            <td>{{ props.item.dataPagamento | azDate('DD/MM/YYYY')}}</td>
                            <td class="table-actions">
                             <v-btn
                                     v-if="props.item.situacao === 'PENDING'"
                                     class="btn-pagar-plano-faturas"
                                     depressed color="#717171"
                                     @click="tratarEventoPagar(props.item)">
                                 Pagar
                             </v-btn>
                            </td>
                        </template>
                    </v-data-table>
                    <div class="az-pagination">
                        <v-pagination v-model="paginacaoInterna.page" :length="paginas"/>
                        <div class="az-select-pagination">
                            <span>Linhas por página:</span>
                            <v-select :items="linhasPorPagina" v-model="paginacaoInterna.rowsPerPage"/>
                        </div>
                    </div>
                </div>
            </az-form>
        </az-container>
    </div>
</template>

<script>
    import {tipoSituacaoCobranca, tipoPagamentoCobranca} from '@/commons/constants'

    export default {
        name: 'PlanoFaturasTabela',
        props: ['itens', 'paginacao', 'paginas', 'totalItens'],
        data() {
            return {
                tipoSituacaoCobranca,
                tipoPagamentoCobranca,
                linhasPorPagina: [10, 25, 50, 100],
                colunas: [
                    {
                        text: 'Plano',
                        value: 'assinatura.planoProduto.nome',
                        sortable: false,
                        align: 'left',
                        width: '150px',
                        class: 'primary--text'
                    },
                    {
                        text: 'Data Início',
                        value: 'assinatura.dataCriacao',
                        sortable: false,
                        align: 'left',
                        width: '100px',
                        class: 'primary--text'
                    },
                    {
                        text: 'Data Fim',
                        value: 'assinatura.dataLimite',
                        sortable: false,
                        align: 'left',
                        width: '100px',
                        class: 'primary--text'
                    },
                    {
                        text: 'Valor',
                        value: 'valor',
                        sortable: false,
                        align: 'left',
                        width: '110px',
                        class: 'primary--text'
                    },
                    {
                        text: 'Meio Pagamento',
                        value: 'tipoPagamento',
                        sortable: false,
                        align: 'left',
                        width: '100px',
                        class: 'primary--text'
                    },
                    {
                        text: 'Situação',
                        value: 'situacao',
                        sortable: false,
                        align: 'left',
                        width: '100px',
                        class: 'primary--text'
                    },
                    {
                        text: 'Data do Pagamento',
                        value: 'dataPagamento',
                        sortable: false,
                        align: 'left',
                        width: '100px',
                        class: 'primary--text'
                    },
                    {
                        text: 'Ações',
                        sortable: false,
                        align: 'center',
                        width: '150px',
                        class: 'primary--text'
                    }
                ],
                paginacaoInterna: this.paginacao
            }
        },
        watch: {
            paginacaoInterna: {
                handler(novoValor) {
                    this.$emit('paginar', novoValor)
                },
                deep: true,
            },
        },
        methods: {
            tratarEventoPagar(item) {
                this.$emit('pagar', item)
            },
        },
    }
</script>

<style scoped lang="stylus">

    .plano-faturas-tabela
        .table-actions
            display flex
            align-items center
            justify-content center

        .v-btn__content
            text-transform none

        .btn-pagar-plano-faturas
            color white !important
            border-radius 5px

        .coluna-situacao-pendente
            color red

</style>